import React, { useState } from "react";
import { useFormik } from "formik";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useDispatch } from "react-redux";
import { handlePostRequest } from "../../services/PostTemplate";
import styles from "./customerDialogs.module.scss";

const ResetPasswordDialog = ({ onHideTyreBrandDialog, onsuccess, email }) => {
    const [role, setRole] = useState();
    const dispatch = useDispatch();
    const [isSubmitting, setIsSubmitting] = useState(false);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            email: email,
            password: "",
        },

        onSubmit: async (data) => {
            if (isSubmitting) return;
            setIsSubmitting(true);
            try {
                data.role = role;
                data.dateJoined = Date.now();
                const result = await dispatch(handlePostRequest(data, "/resetpassword", true, true));
                if (result !== "error") {
                    onsuccess();
                }
            } finally {
                setIsSubmitting(false);
            }
        },
    });

    return (
        <form onSubmit={formik.handleSubmit} className={styles.dialogForm}>
            <div className={styles.fieldsGrid}>
                <div className={`${styles.field} ${styles.fullWidth}`}>
                    <label htmlFor="email">Email Address</label>
                    <InputText disabled id="email" name="email" value={formik.values.email} onChange={formik.handleChange} />
                </div>
                <div className={`${styles.field} ${styles.fullWidth}`}>
                    <label htmlFor="password">New Password</label>
                    <InputText id="password" name="password" value={formik.values.password} onChange={formik.handleChange} />
                </div>
            </div>

            <div className={styles.actions}>
                <Button label={isSubmitting ? "Resetting..." : "Reset"} className={styles.submitButton} disabled={isSubmitting} icon={isSubmitting ? "pi pi-spin pi-spinner" : ""} />
            </div>
        </form>
    );
};

export default ResetPasswordDialog;
